import { default as ButtonComponent } from '../../Button'
import { AIButton } from '../AIButton'
import { AIButtonIconGradientIdPrefix } from '../AIButton.constants'

import * as styles from './AIButtonIcon.module.css'

function AIButtonIcon({
  Button = ButtonComponent.Text,
  Icon,
  beforeIconProps,
  className = styles.aiButtonIcon,
  gradientIdPrefix = AIButtonIconGradientIdPrefix.Icon,
  isLoading,
  ...restProps
}) {
  return (
    <AIButton
      {...restProps}
      Button={Button}
      beforeIconProps={{
        ...beforeIconProps,
        Icon,
      }}
      className={className}
      gradientIdPrefix={gradientIdPrefix}
      isLoading={isLoading}
    />
  )
}

export default AIButtonIcon
